<template>
  <div class="container">
    <a-form
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 10 }"
    >
      <a-form-item
        label="业务流水号"
        has-feedback
      >
        <span>{{ dataSourceInfo.applyNo }}</span>
      </a-form-item>
      <a-form-item
        label="投保申请数据"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.applyData }}</span>
      </a-form-item>
      <a-form-item
        label="数字信封加密"
        has-feedback
      >
        <span class="no-wrap">{{ dataSourceInfo.digitalEnvelope }}</span>
      </a-form-item>
      <a-button
        type="primary"
        size="large"
        class="btnCA"
        @click="btnCA"
      >
        CA锁解密
      </a-button>
      <a-button
        type="primary"
        size="large"
        class="btnBX"
        @click="btnBX"
      >
        标证通解密
      </a-button>
    </a-form>
    <a-modal
      v-model="tipShow"
      class="rules"
      title=""
      centered
      :mask-closable="false"
      @cancel="closeBztModal"
    >
      <img
        v-show="qrcodeImageShow"
        ref="qrcodeImage"
        alt="标证通二维码"
      >
      <template v-slot:footer />
    </a-modal>
  </div>
</template>

<script>
/* global EpCaObj, iWebNet, ThrowEx, QRCode */
import apis from '@/api/insurePreZhongLiang.js';
const {
  buildZhongliangRequestData,
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrContent,
  decryptWithLocalOcx,
  decryptWithFallback,
} = require('./decryptors');
EpCaObj.prototype.Encrypt = function(OrgData) { try { const EncData = { body: { qrinfo: { ext: { CertPath: '' }, decryptobjects: [{ org: OrgData }], qrcodetype: 'Encrypt' } } }; const rtnVRRes = iWebNet.PostMsg(EncData); if (rtnVRRes !== '') { return rtnVRRes.body.qrinfo.decryptobjects[0].encryed; } return ''; } catch (ex) { ThrowEx('加密出现异常，请检查锁是否插好!'); } };
EpCaObj.prototype.Decrypt = function(JiaMiData) { try { const DecData = { body: { qrinfo: { decryptobjects: [{ encryed: JiaMiData }], qrcodetype: 'Decrypt' } } }; const rtnDec = iWebNet.PostMsg(DecData); if (rtnDec !== '') return rtnDec.body.qrinfo.decryptobjects[0].org; return ''; } catch (ex) { ThrowEx('解密过程出现异常，可能的原因：' + ex.description); } };
export default {
  name: 'InsurePreZhongLiang',
  components: {

  },
  data() {
    return {
      dataSourceInfo: {
        applyno: '',
      },
      qrcodeImageShow: false,
      qrcodeid: '',
      timer: null,
      tipShow: false,
    };
  },
  beforeDestroy() {
    this.stopBztPolling();
  },
  methods: {
    decryptWithIWebNet(encryptedEnvelope) {
      iWebNet.Init(104);
      new EpCaObj(true);
      return EpCaObj.prototype.Decrypt(encryptedEnvelope);
    },
    async Inits() {
      const that = this;
      await apis.getPredata({ orderNo: this.$route.query.orderNo }).then(({ data: data }) => {
        that.dataSourceInfo = data;

      });
      try {
        const decryptedEnvelopeRaw = await decryptWithFallback(
          that.dataSourceInfo.digitalEnvelope,
          {
            localDecrypt: decryptWithLocalOcx,
            iwebDecrypt: encryptedEnvelope => this.decryptWithIWebNet(encryptedEnvelope),
          }
        );
        const requestData = buildZhongliangRequestData(
          that.dataSourceInfo.applyNo,
          decryptedEnvelopeRaw
        );
        that.dataSourceInfo.digitalEnvelope = decryptedEnvelopeRaw;
        apis.postDigitalEnvelope({
          type: requestData.type,
          applyno: requestData.applyno,
          encryptkey: requestData.encryptkey,
        }).then(({ data: data }) => {
          window.location.href = data.redirectUrl;
        });
      } catch (error) {
        const message = error && error.message
          ? error.message
          : 'CA解密失败，请稍后重试';
        that.$notification.error({ message });
        return;
      }

    },
    btnCA() {
      this.Inits();

    },
    async btnBX() {
      this.stopBztPolling();
      this.qrcodeImageShow = false;
      this.tipShow = true;

      try {
        const { data } = await apis.getQrcode(
          buildBztQrcodeParams(this.$route.query.orderNo)
        );
        if (data.toInsure === '1') {
          window.location.href = data.redirectUrl;
          return;
        }

        const qrInfo = extractBztQrContent(data);
        this.qrcodeid = qrInfo.qrcodeid;
        const qrcodeUrl = await this.createQrcode(qrInfo.content);
        this.$refs.qrcodeImage.src = qrcodeUrl;
        this.qrcodeImageShow = true;
        this.GetqueryResult();
      } catch (error) {
        this.closeBztModal();
        this.$notification.error({
          message: error && error.message ? error.message : '标证通二维码创建失败，请稍后重试',
        });
      }
    },
    createQrcode(content) {
      return new Promise((resolve, reject) => {
        QRCode.toDataURL(content, (error, url) => {
          if (error) {
            reject(error);
            return;
          }
          resolve(url);
        });
      });
    },
    async GetqueryResult() {
      this.stopBztPolling();
      try {
        const { data } = await apis.getQueryResult(
          buildBztQueryParams(this.$route.query.orderNo, this.qrcodeid)
        );
        if (data.toInsure === '1') {
          window.location.href = data.redirectUrl;
          return;
        }
        if (data.qrstatus === '03') {
          this.closeBztModal();
          this.$notification.warning({ message: '标证通二维码已失效，请重新发起解密' });
          return;
        }
        this.timer = setTimeout(() => {
          this.GetqueryResult();
        }, 10000);
      } catch (error) {
        this.closeBztModal();
        this.$notification.error({
          message: error && error.message ? error.message : '标证通解密状态查询失败',
        });
      }
    },
    stopBztPolling() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    closeBztModal() {
      this.stopBztPolling();
      this.tipShow = false;
      this.qrcodeImageShow = false;
      this.qrcodeid = '';
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  min-height: 726px;
  margin-top: 30px;
  position: relative;
}

.main {
  padding: 30px 50px 95px;
}

.pickCompany {
  margin-top: 90px;
}

.operate {
  margin-top: 80px;
}

.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.no-wrap {
  word-wrap: break-word;
}
.btnCA{
  margin-top: 100px;
  margin-left: 380px;
}
.btnBX{
  margin-top: 100px;
  margin-left: 30px;
}
::v-deep .ant-modal {
  width: 960px !important;
}
::v-deep .ant-modal-content {
  width: 960px !important;
  height: 680px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}
::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}
::v-deep .ant-modal-header,
::v-deep .ant-modal-footer {
  border: none;
}
::v-deep .ant-modal-footer {
  display: none;
}
.rules img {
  display: block;
  width: 360px;
  height: 360px;
  margin: 80px auto;
}
</style>
